// Whether a SIP trunk should expose the SMS tab.
//
// Two independent signals, either of which is sufficient:
//   1. The resolved provider template is tagged `sms` (new trunks created from a
//      built-in/custom template that declares SMS support).
//   2. The trunk is a Twilio trunk, detected from the loaded registrar host
//      (*.twilio.com) or the stored provider name — this covers EXISTING trunks
//      that predate the SMS-tagged template or were created without a stored
//      template_filename, which otherwise never resolve a template and lost the
//      SMS tab. Mirrors 3CX, which surfaces SMS on the Twilio trunk itself.

export function isTwilioTrunk(registrar?: string | null, provider?: string | null): boolean {
  return /\.twilio\.com/i.test(registrar || '')
    || String(provider || '').toLowerCase() === 'twilio';
}

export function trunkHasSms(
  templateHasSmsTag: boolean,
  registrar?: string | null,
  provider?: string | null,
): boolean {
  return !!templateHasSmsTag || isTwilioTrunk(registrar, provider);
}
